import { FC } from 'react';

import { GridLayout, VSpacing } from '@hh.ru/magritte-ui';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import Nav from 'components/Admin/Nav/Nav';
import { YandexDirectReport } from 'components/Admin/YandexDirectReport/YandexDirectReport';

export const YandexDirectReportPage: FC = () => (
    <>
        <AdminHeader />
        <GridLayout>
            <VSpacing default={24} />
            <Nav />
            <YandexDirectReport />
        </GridLayout>
    </>
);
